<template>
  <div class="colorful-background wrapper-grid special">
    <div :class="['img', { animate__animated: isFirst }, 'animate__fadeIn']">
      <image-box img-u-r-l="/pic/10.png"></image-box>
    </div>

    <div :class="['title', { animate__animated: isFirst }, 'animate__flipInX']">
      <span class="small-font">
        在杭电的图书馆,您一共借阅了
      </span>
      <span class="big-font">
        {{ this.$store.state.$data.data.lead.count }}
        <span class="small-font">
          本书籍
        </span>
      </span>
    </div>

    <div
      :class="[
        'text',
        { animate__animated: isFirst },
        'animate__fadeIn',
        'text-align-left',
      ]"
    >
      <span class="small-font">一共预约座位{{ this.$store.state.$data.data.seat.count }}次</span>
      <span class="small-font is-block">一共预约讨论室 {{ this.$store.state.$data.data.room }}次</span>
    </div>

    <div
      :class="[
        'slogan',
        { animate__animated: isFirst },
        'animate__fadeIn',
        ' big-margin-top',
      ]"
    >
      <span class="small-font">
        与ta相处了这么久
      </span>
      <span class="small-font">
        ta诉说了什么呢?
      </span>
      <!--      <span class="small-font">-->
      <!--        你聆听到了什么呢?-->
      <!--      </span>-->
      <span class="small-font">
        与ta的故事又是什么呢？
      </span>
    </div>

    <div class="footer middle-margin-bottom">
      <span class="very-small-font">
        数据由杭电图书馆提供,分析数据均在理想情况下计算
      </span>
      <span class="very-small-font">数据仅供参考</span>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import ImageBox from '@/components/utils/imageBox'

export default {
  name: 'libraryDetailPage',
  components: { ImageBox },
  props: {
    isFirst: { type: Boolean, default: true },
  },
  computed: {
    library: function () {
      return store.state.$data.data.Library
    },
  },
}
</script>

<style scoped>
.title.animate__animated {
  animation-delay: var(--first-delay);
}

.img.animate__animated {
  animation-delay: var(--first-delay);
  animation-duration: var(--defalut-continue);
}

.text.animate__animated {
  animation-delay: var(--second-delay);
  animation-duration: var(--defalut-continue);
}

.slogan.animate__animated {
  animation-delay: var(--third-delay);
  animation-duration: var(--defalut-continue);
}

.special.wrapper-grid {
  --page-background-color: var(--rose-gold);
  --first-color: var(--hdu-school-blue);
  --second-color: var(--quyuan-red);
  --angle: 135deg;
  grid-template-rows: 5vh repeat(4, minmax(auto, auto)) 1fr 5vh;
  grid-template-areas:
    '. .      .'
    '. title   .'
    '. img    .'
    '. text   .'
    '. slogan .'
    '. .      .'
    '. footer .';
}
</style>
